<template>
  <div class="product-detail-container">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="product-heading-mobile">
            <h5>{{ productDetailData.categorytext }}</h5>
            <h1>{{ productDetailData.fullname }}</h1>
          </div>
          <div v-if="!isMobile" class="mixa-carousel-component product-carousel-component">
            <div :id="carouselIdentifier" class="carousel product-detail">
              <div ref="slide" class="carousel-wrapper">
                <div
                  class="carousel-inner"
                  :style="{
                    transform: `translate${'X'}(${currentOffset}px)`,
                    transition: transitionStyle,
                    flexBasis: `${slideWidth}px`,
                    msFlexPreferredSize: `${slideWidth}px`,
                    visibility: `${slideWidth ? 'visible' : 'hidden'}`,
                  }"
                >
                  <slide v-for="slider in productDetailData.productimageslist" :key="slider">
                    <div class="image">
                      <picture>
                        <source media="(max-width: 767px)" :srcset="slider.url" />
                        <source media="(min-width: 768px)" :srcset="slider.url" />
                        <img class="product-main-image" :src="slider.url" alt="" />
                      </picture>
                    </div>
                  </slide>
                </div>
              </div>
              <div v-if="paginationEnabled && pageCount > 0" class="carousel-pagination">
                <ul class="carousel-dot-container">
                  <li
                    v-for="(page, index) in productDetailData.productimageslist"
                    :key="index"
                    class="carousel-dot"
                    :class="{ 'carousel-dot--active': index === currentPage }"
                    @click="goToPage(index, { action: 'display' })"
                  >
                    <span class="product-thumbnail-container"
                      ><img class="product-thumbnail-image" :src="page.url" alt=""
                    /></span>
                    <span class="is-sr-only">{{ goToSlideText }} {{ index }}</span>
                  </li>
                </ul>
              </div>
              <div v-if="paginationEnabled && pageCount > 0" class="carousel-pagination">
                <ul class="carousel-dot-container">
                  <li
                    v-for="(data, index) in productDetailData.productvideolist"
                    :key="index"
                    class="carousel-dot"
                    :class="{ 'carousel-dot--active': index === currentPage }"
                    @click="clickme()"
                  >
                    <span class="product-thumbnail-container">
                      <img class="product-thumbnail-image" :src="data.thumbnail" alt="" />
                    </span>
                    <span class="is-sr-only">{{ goToSlideText }} {{ index }}</span>
                  </li>
                </ul>
              </div>
              <navigation
                v-if="
                  navigationEnabled &&
                  pageCount > 1 &&
                  productDetailData.productimageslist.length != 1
                "
                :next-slide-text="nextSlideText"
                :previous-slide-text="previousSlideText"
                :prev-disabled="isPrevDisabled"
                :next-disabled="isNextDisabled"
                @page-advance-click="advancePage"
              >
              </navigation>
              <div v-if="productDetailData.productimageslist.length != 1" class="slider-count">
                {{ currentPage + 1 }} / {{ pageCount }}
              </div>
            </div>
          </div>
          <div v-if="isMobile">
            <div class="mixa-carousel-component product-carousel-component">
              <div :id="indicatorIdentifier" class="carousel product-detail">
                <div ref="slide" class="carousel-wrapper">
                  <div
                    class="carousel-inner"
                    :style="{
                      transform: `translate${'X'}(${currentOffset}px)`,
                      transition: transitionStyle,
                      flexBasis: `${slideWidth}px`,
                      msFlexPreferredSize: `${slideWidth}px`,
                      visibility: `${slideWidth ? 'visible' : 'hidden'}`,
                    }"
                  >
                    <slide v-for="slider in productDetailData.productimageslist" :key="slider">
                      <div class="image">
                        <picture>
                          <source media="(max-width: 767px)" :srcset="slider.url" />
                          <source media="(min-width: 768px)" :srcset="slider.url" />
                          <img class="product-main-image" :src="slider.url" alt="" />
                        </picture>
                      </div>
                    </slide>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="productDetailData.productimageslist.length != 1"
              class="mixa-carousel-component product-carousel-component"
            >
              <div class="carousel product-detail">
                <div class="carousel-wrapper mobile-carousel-height">
                  <carousel
                    ref="productSlider"
                    :rotate-tag="{ __eventType: 'click' }"
                    :auto-rotate="false"
                    go-to-slide-text="Go to slide"
                    pause-carousel-text="pause carousel"
                    play-carousel-text="play carousel"
                    previous-slide-text="previous slide"
                    next-slide-text="next slide"
                    :navigation-enabled="true"
                    :pagination-enabled="false"
                    :per-page="
                      productDetailData.productimageslist.length > 6
                        ? 6
                        : productDetailData.productimageslist.length
                    "
                    :scroll-per-page="false"
                    :infinite="false"
                  >
                    <slide
                      v-for="(page, index) in productDetailData.productimageslist"
                      :key="index"
                    >
                      <div v-if="paginationEnabled && pageCount > 0" class="carousel-pagination">
                        <div class="carousel-dot-container">
                          <span
                            class="carousel-dot"
                            :class="{ 'carousel-dot--active': index === currentPage }"
                            @click="goToPage(index, { action: 'display' })"
                          >
                            <span class="product-thumbnail-container"
                              ><img class="product-thumbnail-image" :src="page.url" alt=""
                            /></span>
                            <span class="is-sr-only">{{ goToSlideText }} {{ index }}</span>
                          </span>
                        </div>
                      </div>
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div v-if="isdesite == 'true'" class="right-container">
            <h5>{{ productDetailData.categorytext }}</h5>
            <h1>{{ productDetailData.fullname }}</h1>
            <slot name="productBenefitsDesc"></slot>
            <div class="row bottom-container">
              <div class="col-md-4">
                <slot name="bvAverageRating" :allow="allow"></slot>
              </div>
              <div class="col-md-4 user-content">
                <h5>{{ userReviewTitle }}</h5>
                <p v-if="productDetailData.userreviewone" class="first">
                  {{ productDetailData.userreviewone }}
                </p>
                <p v-if="productDetailData.userreviewtwo" class="second">
                  {{ productDetailData.userreviewtwo }}
                </p>
                <div v-if="allow" class="btn-container">
                  <a
                    href="#reviews"
                    role="button"
                    class="btn-txt mixa-redesign-footer-btn"
                    @click="readReviewtagging()"
                  >
                    <strong> {{ writeReviewText }}</strong>
                  </a>
                </div>
              </div>
              <div class="col-md-4">
                <div class="btn-container">
                  <template v-if="allow">
                    <!-- NOSONAR -->
                    <a
                      :href="productDetailData.writereviewurl"
                      role="button"
                      class="btn-border mixa-redesign-footer-btn"
                    >
                      <strong>{{ readReviewText }}</strong>
                    </a>
                  </template>
                  <button
                    v-if="isVisibleCC"
                    class="btn-bg mixa-redesign-footer-btn"
                    @click="fireButtonAction()"
                  >
                    <strong>{{ buyOnlineText }}</strong>
                  </button>
                  <!-- NOSONAR -->
                  <a
                    v-else
                    :href="productDetailData.ctanavigation"
                    role="button"
                    class="btn-bg mixa-redesign-footer-btn"
                    @click="buyNowTagging()"
                  >
                    <strong>{{ buyOnlineText }}</strong>
                  </a>
                  <commerce-connect-cta-modal
                    :commerce-online-title="commerceOnlineTitle"
                    :commerce-popup-data="commercePopupData"
                  ></commerce-connect-cta-modal>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isdesite == 'false'" class="right-container not-de-site">
            <h5>{{ productDetailData.categorytext }}</h5>
            <h1>{{ productDetailData.fullname }}</h1>
            <slot name="productBenefitsDesc"></slot>
            <div class="btn-container">
              <!-- NOSONAR -->
              <a
                :href="productDetailData.ctanavigation"
                role="button"
                class="btn-bg mixa-redesign-footer-btn"
                @click="buyNowTagging()"
              >
                <strong>{{ buyOnlineText }}</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="videoModelShow" id="videoModel" class="modal">
      <div class="wsf-modal-backdrop">
        <div class="wsf-modal" role="dialog">
          <div class="wsf-modal__close">
            <button
              type="button"
              :aria-label="ariaLabel"
              class="btn-close js-focusable"
              @click="closeVideo()"
            >
              <span>×</span>
            </button>
          </div>
          <iframe
            id="widget2"
            allowfullscreen="1"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title="YouTube video player"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=0;enablejsapi=1"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-slots-as-functions */
import Vue from 'vue';
import debounce from 'lodash/debounce';
import navigation from '../carousel/navigation.vue';
import { EventBus } from '../../mixins/event.js';
import { OTConsentEmitters } from '../../mixins/constants';

const MILLISECONDS_PER_SECOND = 1000;

export default {
  name: 'mixa-product-detail',
  components: {
    navigation,
  },
  props: {
    userReviewTitle: {
      type: String,
      required: false,
    },
    writeReviewText: {
      type: String,
      required: false,
    },
    readReviewText: {
      type: String,
      required: false,
    },
    buyOnlineText: {
      type: String,
      required: false,
    },
    isDesite: {
      type: String,
      default: 'false',
    },
    // slide transition easing. any valid CSS transition easing accepted
    easing: {
      type: String,
      default: 'ease',
    },

    // Minimum distance for the swipe to trigger a slide advance
    minSwipeDistance: {
      type: Number,
      default: 50,
    },

    // Flag to render the slide component (next/prev buttons)
    navigationEnabled: {
      type: Boolean,
      default: true,
    },

    // Flag to render pagination component
    paginationEnabled: {
      type: Boolean,
      default: true,
    },

    // Maximum number of slides displayed on each page
    perPage: {
      type: Number,
      default: 1,
    },

    // the offset between items
    slideSpacing: {
      type: Object,
      default: () => ({}),
    },

    // padding for the slides
    slidePadding: {
      type: Number,
      default: 0,
    },

    /**
     * Configure the number of visible slides with a particular browser width.
     * This will be an array of arrays, ex. [[320, 2], [1199, 4]]
     * Formatted as [x, y] where x=browser width, and y=number of slides displayed.
     * ex. [1199, 4] means if (window <= 1199) then show 4 slides per page
     */
    perPageCustom: {
      type: Array,
    },

    // Scroll per page, not per item
    scrollPerPage: {
      type: Boolean,
      default: true,
    },

    // slide transition speed. Number of milliseconds accepted
    speed: {
      type: Number,
      default: 400,
    },

    // Start at slide
    startAt: {
      type: Number,
      default: 0,
    },

    productDetailData: {
      required: true,
      type: Object,
    },

    // Start at slide
    carouselIdentifier: {
      type: String,
      default: () => `carousel-${Date.now()}`,
    },
    indicatorIndentifier: {
      type: String,
      default: () => `indicator-${Date.now()}`,
    },
    // If the carousel should automatically rotate to next slide.
    autoRotate: {
      type: Boolean,
      default: false,
    },

    // # of seconds before rotating to the next slide.
    rotationTiming: {
      type: Number,
      default: 5,
    },

    // Infinite loop
    infinite: {
      type: Boolean,
      default: true,
    },

    // Tag to fire when carousel rotates to a new slide
    rotateTag: {
      type: Object,
      required: true,
    },

    goToSlideText: {
      type: String,
      required: true,
    },
    previousSlideText: {
      type: String,
      required: true,
    },
    nextSlideText: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productSku: {
      type: String,
      required: true,
    },
    productEan: {
      type: String,
      required: true,
    },
    isVisibleCC: {
      type: Boolean,
      default: true,
    },
    commerceOnlineTitle: {
      type: String,
      required: true,
    },

    commercePopupData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      browserWidth: null,
      carouselSize: null,
      currentPage: this.startAt,
      prevPage: this.startAt,
      dragOffset: 0,
      dragStartX: 0,
      mousedown: false,
      slideCount: 0,
      maxSwipeAngle: 40,
      isAutoRotating: this.autoRotate,
      scrolling: false,
      isMobile: false,
      videoModelShow: false,
      allow: false,
      otReviewEmitter: OTConsentEmitters.OTBazaarVoiceEmitter,
    };
  },
  computed: {
    /**
     * Given a viewport width, find the number of slides to display
     * @return {Number}       Number of slides to display
     */
    breakpointSlidesPerPage() {
      if (!this.perPageCustom) {
        return this.perPage;
      }

      const breakpointArray = this.perPageCustom;
      const width = this.browserWidth;

      const breakpoints = breakpointArray.sort((a, b) => (a[0] > b[0] ? -1 : 1));

      // Reduce the breakpoints to entries where the width is in range
      // The breakpoint arrays are formatted as [widthToMatch, numberOfSlides]
      const matches = breakpoints.filter((breakpoint) => width >= breakpoint[0]);

      // If there is a match, the result should return only
      // the slide count from the first matching breakpoint
      const match = matches[0] && matches[0][1];

      return match || this.perPage;
    },

    /**
     * @return {Boolean} Can the slider move forward?
     */
    canAdvanceForward() {
      return this.currentPage < this.pageCount - 1;
    },

    /**
     * @return {Boolean} Can the slider move backward?
     */
    canAdvanceBackward() {
      return this.currentPage > 0;
    },

    /**
     * Number of slides to display per page in the current context.
     * This is constant unless responsive perPage option is set.
     * @return {Number} The number of slides per page to display
     */
    currentPerPage() {
      return !this.perPageCustom || this.$isServer ? this.perPage : this.breakpointSlidesPerPage;
    },

    /**
     * The horizontal distance the inner wrapper is offset while navigating.
     * @return {Number} Pixel value of offset to apply
     */
    currentOffset() {
      const page = this.currentPage;
      const width = this.slideWidth;
      const dragged = this.dragOffset;

      // The offset distance depends on whether the scrollPerPage option is active.
      // If this option is active, the offset will be determined per page rather than per item.
      const offset = this.scrollPerPage ? page * width * this.currentPerPage : page * width;
      const currentOffset = (offset + dragged) * -1;
      const slideSpacing = this.getSlideSpacing();

      return currentOffset + slideSpacing;
    },

    isHidden() {
      return this.carouselSize <= 0;
    },

    /**
     * Calculate the number of pages of slides
     * @return {Number} Number of pages
     */
    pageCount() {
      const slideCount = this.slideCount;
      const perPage = this.currentPerPage;

      if (this.scrollPerPage) {
        const pages = Math.ceil(slideCount / perPage);
        return pages < 1 ? 1 : pages; // Be sure to not round down to zero pages
      }

      return slideCount - (this.currentPerPage - 1);
    },

    /**
     * Calculate the width of each slide
     * @return {Number} slide width
     */
    slideWidth() {
      const width = this.carouselSize;
      const perPage = this.currentPerPage;
      const slideWidth = width / perPage;

      return slideWidth - this.getSlideSpacing() * 2;
    },

    transitionStyle() {
      return `${this.speed / 1000}s ${this.easing} transform`;
    },

    isPrevDisabled() {
      return !this.infinite && !this.canAdvanceBackward;
    },

    isNextDisabled() {
      return !this.infinite && !this.canAdvanceForward;
    },
  },
  beforeUpdate() {
    this.computeCarouselSize();
  },

  mounted() {
    this.isdesite = this.isDesite.toLowerCase();
    /* istanbul ignore if: this will never execute, b/c testing is "server-side" */
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('keydown', this.controlKeyHandler);
    if (!this.$isServer) {
      window.addEventListener('resize', debounce(this.computeCarouselSize, 16));

      let scrollTimer = null;
      window.addEventListener('scroll', () => {
        this.scrolling = true;
        window.clearInterval(scrollTimer);
        scrollTimer = setTimeout(() => {
          this.scrolling = false;
        }, 500);
      });
      if (!this.isMobile) {
        if ('ontouchstart' in window) {
          this.$refs.slide.addEventListener('touchstart', this.handleMousedown);
          this.$refs.slide.addEventListener('touchend', this.handleMouseup);
          this.$refs.slide.addEventListener('touchmove', this.handleMousemove);
        } else {
          this.$refs.slide.addEventListener('mousedown', this.handleMousedown);
          this.$refs.slide.addEventListener('mouseup', this.handleMouseup);
          this.$refs.slide.addEventListener('mousemove', this.handleMousemove);
        }
      }
      if (this.isMobile) {
        if ('ontouchstart' in window) {
          this.$refs.slide.addEventListener('touchstart', this.handleMousedown);
          this.$refs.slide.addEventListener('touchend', this.handleMouseup);
          this.$refs.slide.addEventListener('touchmove', this.handleMousemove);
        } else {
          this.$refs.slide.addEventListener('mousedown', this.handleMousedown);
          this.$refs.slide.addEventListener('mouseup', this.handleMouseup);
          this.$refs.slide.addEventListener('mousemove', this.handleMousemove);
        }
      }

      this.scheduleAutoRotate();
      this.attachMutationObserver();
    }
    let prmstr = window.location.search.slice(1);
    if (prmstr != null && prmstr != '') {
      this.videoModelFunc();
    }
    EventBus.$on('cookiesStatusUpdate', (status) => (this.allow = status));
  },

  created() {
    this.computeCarouselSize();
    // Compute again on next tick for dynamic slides
    Vue.nextTick(() => {
      this.computeCarouselSize();
    });
    EventBus.$on(OTConsentEmitters.OTBazaarVoiceEmitter, (status) => (this.allow = status));
  },
  beforeDestroy() {
    /* istanbul ignore if: this will never execute, b/c testing is "server-side" */
    if (!this.$isServer) {
      this.cancelRotate();
      this.detachMutationObserver();
      window.removeEventListener('resize', this.getBrowserWidth);
      window.removeEventListener('keydown', this.controlKeyHandler);
      if ('ontouchstart' in window) {
        this.$el.removeEventListener('touchmove', this.handleMousemove);
      } else {
        this.$el.removeEventListener('mousemove', this.handleMousemove);
      }
    }
  },
  methods: {
    /**
     * Increase/decrease the current page value
     * @param  {String} direction (Optional) The direction to advance
     * @param {boolean} auto - Whether this was triggered automatically.
     */
    navigateUrl(url) {
      window.location.href = url;
    },
    buyNowTagging() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'Ecommerce',
        eventAction: 'click to buy',
        eventLabel: `${this.productName}::${this.productSku}`,
        ecommerce: 'undefined',
        event_name: 'buy_now',
        product_info: `${this.productName}::${this.productDetailData.productid}`,
      });
    },
    readReviewTagging() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'Ecommerce',
        eventAction: 'product detail page',
        eventLabel: `${this.productName}::${this.productSku}`,
        ecommerce: 'undefined',
      });
    },
    controlKeyHandler(event) {
      if (event.code === 'Home' && event.ctrlKey && event.keyCode === 36) {
        document.getElementById('desktop-tab').classList.remove('desktop-sticky');
      }
    },
    advancePage(direction) {
      if (direction && direction === 'backward') {
        if (this.canAdvanceBackward) {
          this.goToPage(this.currentPage - 1);
        } else if (this.infinite) {
          this.goToPage(this.pageCount - 1);
        }
      } else if (!direction || direction !== 'backward') {
        if (this.canAdvanceForward) {
          this.goToPage(this.currentPage + 1);
        } else if (this.infinite) {
          this.goToPage(0);
        }
      }

      this.cancelAndRescheduleRotate();
    },

    /**
     * A mutation observer is used to detect changes to the containing node
     * in order to keep the magnet container in sync with the height its reference node.
     * Note: This does not work for ie10.
     */
    attachMutationObserver() {
      const MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

      /* istanbul ignore if: no mutation observer in jest tests */
      if (MutationObserver) {
        const config = {
          attributes: true,
          data: true,
        };
        this.mutationObserver = new MutationObserver(() => {
          this.$nextTick(() => {
            this.computeCarouselSize();
          });
        });
        if (this.$parent.$el) {
          this.mutationObserver.observe(this.$parent.$el, config);
        }
      }
    },

    getSlideSpacing() {
      let value = 0;
      for (const key in this.slideSpacing) {
        if (Object.prototype.hasOwnProperty.call(this.slideSpacing, key)) {
          if (key <= this.getBrowserWidth()) value = this.slideSpacing[key];
        }
      }
      return value;
    },

    /**
     * Stop listening to mutation changes
     */
    detachMutationObserver() {
      /* istanbul ignore if: no mutation observer in jest tests */
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    },

    /**
     * Get the current browser viewport width
     * @return {Number} Browser"s width in pixels
     */
    getBrowserWidth() {
      this.browserWidth = window.innerWidth;
      return this.browserWidth;
    },

    /**
     * Get the width of the carousel DOM element
     * @return {Number} Width of the carousel in pixels
     */
    getCarouselSize() {
      this.carouselSize = (this.$el && this.$el.clientWidth) || 0; // Assign globally
      return this.carouselSize;
    },

    /**
     * Filter slot contents to slide instances and return length
     * @return {Number} The number of slides
     */
    getSlideCount() {
      this.slideCount = this.productDetailData.productimageslist.length;
    },

    /**
     * Set the current page to a specific value
     * This function will only apply the change if the value is within the carousel bounds
     * @param  {Number} page The value of the new page number
     * @param {string} [action] - Tag
     * @param {boolean} auto - Whether this was automatically called.
     */
    goToPage(page) {
      if (page >= 0 && page < this.pageCount) {
        this.currentPage = page;
        this.$emit('pageChange', this.currentPage);

        /* istanbul ignore if: no eventBus in tests */
        if (window.eventBus) {
          window.eventBus.$emit(
            `${this.carouselIdentifier}-pageChange`,
            this.currentPage,
            this.prevPage,
          );
        }
        this.prevPage = this.currentPage;
      }
    },

    /**
     * Get the tag for the current slide.
     *
     * @return {string} The tag name for the current slide.
     */
    getSlideTagName() {
      if (this.$slots && this.$slots.default && this.$slots.default.length) {
        const slides = this.$slots.default.filter(
          (slide) => slide.tag && slide.tag.indexOf('slide') !== -1,
        );
        const currentSlide = slides[this.currentPage];

        if (currentSlide) {
          return currentSlide.componentInstance.tagName;
        }
      }

      return `slide ${this.currentPage}`;
    },

    /**
     * Trigger actions when mouse is pressed
     * @param  {Object} e The event object
     */
    handleMousedown(e) {
      if (this.scrolling) return;

      if (!e.touches) {
        e.preventDefault();
      }

      this.mousedown = true;
      this.dragStart = e.touches ? e.touches[0] : e;
    },

    /**
     * Trigger actions when mouse is released
     */
    handleMouseup() {
      this.mousedown = false;
      this.dragOffset = 0;
    },

    /**
     * We know the main Distance swiped and the sub direction distance swiped
     * based on that we can calculate the swipe angle
     * @param {number} main
     * @param {number} sub
     * @returns {number} the angle based on Tangent: tan(Î¸) = Opposite / Adjacent
     */
    swipeAngle(main, sub) {
      return Math.atan(Math.abs(sub) / Math.abs(main)) * (180 / Math.PI);
    },

    /**
     * Trigger actions when mouse is pressed and then moved (mouse drag)
     * @param  {Object} e The event object
     */

    handleMousemove(e) {
      /* istanbul ignore next: how can we test this? mock event object? */
      if (!this.mousedown || this.scrolling) return;

      const event = e.touches ? e.touches[0] : e;

      let mainDirectionDragDistance = 0;
      let subDirectionDragDistance = 0;

      mainDirectionDragDistance = this.dragStart.clientX - event.clientX;
      subDirectionDragDistance = this.dragStart.clientY - event.clientY;

      const angle = this.swipeAngle(mainDirectionDragDistance, subDirectionDragDistance);

      /**
       * If the swipe angle is less then the max swipe angle then
       * the user is probably using the slideshow to see the next slide
       *
       * We want to use prevent default to prevent the page from scrolling when switching to a new slide.
       */
      if (angle < this.maxSwipeAngle) {
        e.preventDefault();
      }

      this.dragOffset = mainDirectionDragDistance;

      if (this.dragOffset > this.minSwipeDistance) {
        this.handleMouseup();
        this.advancePage();
      } else if (this.dragOffset < -this.minSwipeDistance) {
        this.handleMouseup();
        this.advancePage('backward');
      }
    },

    /**
     * Re-compute the width of the carousel and its slides
     */
    computeCarouselSize() {
      this.getSlideCount();
      this.getBrowserWidth();
      this.getCarouselSize();
    },

    /**
     * Schedules for
     */
    scheduleAutoRotate() {
      if (!this.autoRotate) {
        return;
      }

      this.isAutoRotating = true;
      this.rotationTimeout = setTimeout(() => {
        this.advancePage('forward', {
          auto: true,
        });
      }, this.rotationTiming * MILLISECONDS_PER_SECOND);
    },

    cancelRotate() {
      this.isAutoRotating = false;
      clearTimeout(this.rotationTimeout);
    },

    cancelAndRescheduleRotate() {
      this.cancelRotate();
      this.scheduleAutoRotate();
    },

    toggleAutoRotation() {
      if (this.isAutoRotating) {
        this.cancelRotate();
      } else {
        this.cancelAndRescheduleRotate();
      }
    },
    videoModelFunc() {
      this.videoModelShow = true;
    },
    closeVideo() {
      this.videoModelShow = false;
    },
    fireButtonAction() {
      window.eventBus.$emit('commerceConnectButtonModal');
    },
  },
};
</script>
